// Production variables - these placeholders will be replaced during CDK deployment
export const ProdVariables = {
  COGNITO_USER_POOL_ID: 'INJECT_COGNITO_USER_POOL_ID',
  COGNITO_CLIENT_ID: 'INJECT_COGNITO_CLIENT_ID',
  IDENTITY_POOL_ID: 'INJECT_IDENTITY_POOL_ID',
  API_ENDPOINT: 'INJECT_API_ENDPOINT',
  JOBS_API_ENDPOINT: 'INJECT_JOBS_API_ENDPOINT',
  REGION: 'INJECT_REGION',
  AGENT_GATEWAY_URL: 'INJECT_AGENT_GATEWAY_URL',
  EMPLOYEE_API_ENDPOINT: 'INJECT_EMPLOYEE_API_ENDPOINT',
  EMPLOYEE_USER_POOL_ID: 'INJECT_EMPLOYEE_USER_POOL_ID',
  EMPLOYEE_CLIENT_ID: 'INJECT_EMPLOYEE_CLIENT_ID',
  SIMULATOR_API_ENDPOINT: 'INJECT_SIMULATOR_API_ENDPOINT',
};
